import "../styles/edu.css"
function Sskill() {
    return(<div class="">
        <div class="container px-5 ">
        <div class="relative  overflow-hidden  bg-gradient-to-br  from-[hsl(0,0%,100%)] to-[hsl(0,0%,100%)] ]">
                <section id="about" class=" py-10 md:py-20  relative space-y-16 p-6  justify-center items-center flex flex-col  " >
                            <h2 class="text-black font-bold mb-4">Educa<span class="text-blue-600">tion</span></h2>
                            {/* <!-- Education Card 1--> */}
                            <div class="card shadow border-0 rounded-4 mt-7 mb-5">
                                <div class="card-body p-5">
                                    <div class="row align-items-center gx-5">
                                        <div class="col text-center text-lg-start mb-4 mb-lg-0">
                                            <div class="bg-light p-4 rounded-4">
                                            <div class="fst-italic">
                                                    <div class=" text-black font-bold">Master's of </div>
                                                    <div class=" text-black font-bold">Computer Application</div>
                                                    <div class=" text-black font-bold">(MCA)</div>
                                                </div>
                                                {/* <br /> */}
                                                <div class="text-secondary fw-bolder mt-2 mb-2"><span class="text-blue-600">2021 - 2023</span></div>
                                                <div class="mb-2">
                                                    <div class="small fw-bolder">Pes University</div>
                                                    <div class="small text-muted">Bengaluru, <span class="text-blue-600">KA</span></div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="col-lg-8"><div>I pursued my Master of Computer Application degree at PES University, where I immersed myself in the comprehensive curriculum and engaging learning environment. Throughout my academic journey, I delved into various subjects, honed my technical skills, and collaborated with peers and professors who shared the same passion for computer science. The experience equipped me with a profound understanding of computer applications and their real-world implications, preparing me to confidently step into the professional realm of technology.</div></div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Education Card 2--> */}
                            <div class="card shadow border-0 rounded-4 mt-1 mb-5">
                                <div class="card-body p-5">
                                    <div class="row align-items-center gx-5">
                                        <div class="col text-center text-lg-start mb-4 mb-lg-0">
                                            <div class="bg-light p-4 rounded-4">
                                            <div class="fst-italic">
                                                    <div class=" text-black font-bold">Bachelor of Science</div>
                                                    <div class=" text-black font-bold"></div>
                                                    <div class=" text-black font-bold">(PMCs)</div>
                                                </div>
                                                {/* <br /> */}
                                                <div class="text-secondary fw-bolder  mt-2 mb-2"><span class="text-blue-600">2017 - 2020</span></div>
                                                <div class="mb-2">
                                                    <div class="small fw-bolder">Yuvaraja's College</div>
                                                    <div class="small text-muted">Mysore, <span class="text-blue-600">KA</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8"><div>I pursued a Bachelor's degree in Physics, Mathematics, Computer Science BSc (PMCS) from Yuvaraja's College. As a student, my academic focus was on mastering the subjects of Physics, Mathematics, and Computer Science through the program at Yuvaraja's College.</div></div>
                                    </div>
                                </div>
                            </div>
                        </section>

        </div>
        </div>
        </div>
    );
}
export default Sskill;